/*
 * @copyright Copyright (c) 2022 Max <max@nextcloud.com>
 *
 * @author Max <max@nextcloud.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */

/**
 * @param {object} md Markdown object
 */
export default function markdownUnderlines(md) {
	md.inline.ruler2.after('emphasis', 'underline', state => {
		const tokens = state.tokens

		for (let i = tokens.length - 1; i > 0; i--) {
			const token = tokens[i]

			if (token.markup === '__') {
				if (token.type === 'strong_open') {
					tokens[i].tag = 'u'
					tokens[i].type = 'u_open'
				}
				if (token.type === 'strong_close') {
					tokens[i].tag = 'u'
					tokens[i].type = 'u_close'
				}
			}
		}

		return false
	})
}
